"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const customersCopy_1 = require("copy/customersCopy");
const ErrorMessage = () => (react_1.default.createElement(polaris_1.Banner, { status: 'critical', title: 'Cannot load customers' },
    react_1.default.createElement("p", null, customersCopy_1.customersCopy.fetchError)));
exports.ErrorMessage = ErrorMessage;
